import axiosInstance from "../server/axios";

const token = localStorage.getItem('authToken')

export const getStock = (type_id) => {
    return axiosInstance.get(`/getStock/${type_id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}